import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import styled from "styled-components";
import Back from "sushiweb/Icons/all/Back";
import Breadcrumb from "sushiweb/Breadcrumb";
import Button from "sushiweb/Button";
import { FlexContainer } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { getPath, isMobile, isValNull } from "../../../utils";
import ForceCompleteModal from "../Actions/Modals/ForceComplete";
import UnassignModal from "../Actions/Modals/UnassignOrder";
import CancelModal from "../Actions/Modals/CancelOrder";
import { Repeat } from "sushiweb/Icons";


const orderActionCancel = {
  label: "Cancel order",
  key: "cancel_order",
};
const orderActionForceComplete = {
  label: "Force complete order",
  key: "force_complete_order",
};
const orderActionUnassign = {
  label: "Unassign order",
  key: "unassign_order",
};

const TopActionBar = ({ id, orderMeta, allMenuActions, refresh, reasonCodes }) => {
  const [action, setAction] = useState("");
  const history = useHistory();

  const handleChange = (key, val) => {
    setAction(val);
  };

  const handleClose = () => {
    setAction("");
  };

  const getActionOptions = () => {
    let actions = [];
    let state = (orderMeta || {}).state;
    let driver_id = (orderMeta || {}).driver_id;
    if (getPath(allMenuActions, "ORDERS_EDIT")) {
      var reason_codes_for_cancel_order =  (reasonCodes || {})?.reason_codes_for_cancel_order;
      if (reason_codes_for_cancel_order?.length > 0) {
        actions.push(orderActionCancel);
      }

      var reason_codes_for_unassign_order =  (reasonCodes || {})?.reason_codes_for_unassign_order;
      if(reason_codes_for_unassign_order?.length > 0) {
        actions.push(orderActionUnassign);
      }

      var reason_codes_for_force_complete_order =  (reasonCodes || {}).reason_codes_for_force_complete_order;
      if(reason_codes_for_force_complete_order?.length > 0) {
        actions.push(orderActionForceComplete);
      } 
    }
    return actions;
  };

  const modalForCurrentAction = () => {
    var trip_id,driver_id,reason_codes_for_unassign_order, reason_codes_for_force_complete_order, reason_codes_for_cancel_order, state;
    trip_id = (orderMeta || {}).trip_id;
    driver_id = (orderMeta || {}).driver_id;
    reason_codes_for_unassign_order =  (reasonCodes || {}).reason_codes_for_unassign_order;
    reason_codes_for_force_complete_order =  (reasonCodes || {}).reason_codes_for_force_complete_order;
    reason_codes_for_cancel_order =  (reasonCodes || {}).reason_codes_for_cancel_order;
    state = (orderMeta || {}).state;

    switch (action) {
      case "cancel_order":
        if (reason_codes_for_cancel_order?.length > 0) {
          return (
            <CancelModal order_id={id} handleClose={handleClose} reason_codes={reason_codes_for_cancel_order} />
          );
      }
      case "force_complete_order":
        if (!isValNull(trip_id) && reason_codes_for_force_complete_order?.length > 0) {
          return (
            <ForceCompleteModal
              order_id={id}
              trip_id={trip_id}
              handleClose={handleClose}
              reason_codes={reason_codes_for_force_complete_order}
            />
          );
        }
      case "unassign_order":
        if (reason_codes_for_unassign_order?.length > 0) {
             return (
              <UnassignModal
                order_id={id}
                trip_id={trip_id}
                driver_id = {driver_id}
                reason_codes = {reason_codes_for_unassign_order}
                handleClose={handleClose}
              />
            );
        }

      default:
        return <div />;
    }
  };

  return (
    <TopActionBarContainer className="mb-30">
      <LeftContainer justify="flex-start">
        <Back
          onClick={() => {
            history.replace("/orders");
          }}
          className="mr-10 backBtn"
          color={variables.grey400}
        />
        <Breadcrumb className="sushi-breadcrumbs">
          <Breadcrumb.Link
            onClick={() => {
              history.replace("/orders");
            }}
          >
            Orders
          </Breadcrumb.Link>
          <Breadcrumb.Link>{id}</Breadcrumb.Link>
        </Breadcrumb>
      </LeftContainer>

      <RightContainer justify="flex-end">
        <Button
          icon={<Repeat />}
          appearance="outline"
          onClick={() => {
            refresh(id);
          }}
        >
          {" "}
          Refresh
        </Button>
        {getActionOptions().length > 0 && (
          <PaginatedReactDropdown
            options={getActionOptions()}
            width={isMobile() ? "100%" : "60%"}
            labelKey="label"
            valueKey="key"
            noLabelSelect
            className="actionDropdown"
            handleChange={handleChange}
            value=""
            keyToChange="action"
            placeholder="Take action"
            id={`actionDropdownDeliveryDrivers`}
          />
        )}
        {modalForCurrentAction()}
      </RightContainer>
    </TopActionBarContainer>
  );
};

const TopActionBarContainer = styled(FlexContainer)`
  flex-direction: ${isMobile() ? "column" : "row"};
`;

const LeftContainer = styled(FlexContainer)`
  flex: 0 1 30%;
  margin-bottom: ${isMobile() ? "20px" : "unset"};
  & > div {
    flex-direction: ${isMobile() ? "row" : "column"};
  }
`;

const RightContainer = styled(FlexContainer)`
  flex: ${({ flexpct }) => (flexpct ? `0 1 ${flexpct}%` : "0 1 35%")};
  .actionDropdown {
    width: 100%;
    margin-bottom: unset;
  }
`;

export default TopActionBar;
